import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class Poll {
    public pollID: string = '';
    public label: string = '';
    public options: string[] = [];
    public poll_start: Date|null = null;
    public poll_end: Date|null = null;
    public votes: number[] = [];
    public voterIDs: string[] = [];
    public viewable_committee_typeIDs: string[] = [];
    public hostID: string = '';
    public datetime_created: Date|null = null;
    
    constructor(
        pollID: string,
        label: string,
        options: string,
        poll_start: string,
        poll_end: string,
        votes: string,
        voterIDs: string,
        viewable_committee_typeIDs: string,
        hostID: string,
        datetime_created: string
    ) {
        this.pollID = this[CheckNotNull](pollID) ? pollID : '';
        this.label = this[CheckNotNull](label) ? label : '';
        this.options = this[CheckNotNull](options) ? options.split(':;:') : [];
        this.poll_start = this[CheckNotNull](poll_start) ? IonDate(poll_start) : null;
        this.poll_end = this[CheckNotNull](poll_end) ? IonDate(poll_end) : null;
        this.votes = this[CheckNotNull](votes) ? votes.split(',').map((v: string) => parseInt(v)) : [];
        this.voterIDs = this[CheckNotNull](voterIDs) ? voterIDs.split(',') : [];
        this.viewable_committee_typeIDs = this[CheckNotNull](viewable_committee_typeIDs) ? viewable_committee_typeIDs.split(',') : [];
        this.hostID = this[CheckNotNull](hostID) ? hostID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
    }

    //symbolic methods
    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default Poll;